
import React , {useState} from "react";
import Library from 'library';
import styles from './index.module.scss';
import { umengTrack_healthcare } from 'library/jsbridge/config';
import icon3 from "images/kangyang/general-btn-phone@2x.png";
const { Fetch, Platform, JsBridge } = Library;

export const BottomButton = (props) => {
    const [show,setShow] = useState(false);
    return <div className={`${styles.bottomButton} ${window.pageConfig && window.pageConfig.isFullscreen ? styles.active : ''}`}>
        <div className={styles.content}>
            <div className={styles.tel} onClick={() => {
                setShow(true);
            }}>
                <img className={styles.telIcon} src={icon3} />
                <a className={styles.telText}>电话</a>
            </div>
            {/* 改了括号 */}
            <button className={styles.button} onClick={() => {
                props.onClick();
                if (Platform.check.isApp()) {
                    JsBridge.UmengTrack(umengTrack_healthcare.submit);
                }
            }}>立即预约</button>
        </div>

        {
            show?<div className={styles.modal} onClick={()=>setShow(false)}>
                    <div className={styles.content}>
                        <div className={styles.phone} onClick={()=>{
                            if (Platform.name() === 'GuApp') {
                                JsBridge.tel('021-63088257');
                            } else {
                                window.location.href = 'tel:021-63088257';
                            }
                            if (Platform.check.isApp()) {
                                JsBridge.UmengTrack(umengTrack_healthcare.phone);
                            }
                        }}>
                            021-63088257
                        </div>
                        <div className={styles.line}></div>
                        <div className={styles.phone} onClick={()=>{
                            if (Platform.name() === 'GuApp') {
                                JsBridge.tel('15921166845');
                            } else {
                                window.location.href = 'tel:15921166845';
                            }
                            if (Platform.check.isApp()) {
                                JsBridge.UmengTrack(umengTrack_healthcare.phone);
                            }
                        }}>
                            15921166845
                        </div>
                        <div className={styles.line}></div>
                        <div className={styles.phone} onClick={()=>setShow(false)}>
                            取消
                        </div>
                    </div>
                  
                </div>:null
            }
    </div>
}